import React from 'react';
import './InfoPopup.css';

interface InfoPopupProps {
  show: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

export const InfoPopup: React.FC<InfoPopupProps> = ({ show, onClose, title, children }) => {
  if (!show) return null;

  return (
    <div className="info-popup-overlay" onClick={onClose}>
      <div className="info-popup" onClick={(e) => e.stopPropagation()}>
        <div className="info-popup-header">
          <h3>{title}</h3>
          <button className="info-popup-close" onClick={onClose}>×</button>
        </div>
        <div className="info-popup-content">
          {children}
        </div>
        <div className="info-popup-footer">
          <button className="info-popup-button" onClick={onClose}>Got it!</button>
        </div>
      </div>
    </div>
  );
};